export const ARCHIVED_CHANNEL_COPY_TOOLTIP =
  "Unarchive this channel before copying its messages.";
export const ARCHIVED_CHANNEL_ENABLE_TOOLTIP =
  "Unarchive this channel before enabling its messages.";

export function withArchivedSuffix(label: string, enabled: boolean): string {
  return enabled ? label : `${label} (archived)`;
}
